import { useState } from 'react';

export default function ConsultationDrawer() {
  const [formData, setFormData] = useState({
    phone: '',
    revenue: '',
    needTaxService: false,
    note: ''
  });

  const [submitted, setSubmitted] = useState(false);

  const closeDrawer = () => {
    const drawer = document.getElementById('consultation-drawer');
    if (drawer) drawer.classList.add('translate-x-full');
    setTimeout(() => setSubmitted(false), 300);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setSubmitted(true);
  };

  return (
    <>
      {/* Overlay */}
      <div
        id="consultation-overlay"
        className="fixed inset-0 bg-black/60 z-40 hidden"
        onClick={closeDrawer}
      ></div>

      {/* Drawer */}
      <div
        id="consultation-drawer"
        className="fixed top-0 right-0 h-full w-full md:w-[480px] bg-white shadow-2xl z-50 transform translate-x-full transition-transform duration-300"
      >
        {/* Header */}
        <div className="h-[72px] bg-gray-50 flex items-center justify-between px-8 border-b border-gray-200">
          <h3 className="text-xl font-bold text-gray-800">咨询报价</h3>
          <button
            onClick={closeDrawer}
            className="w-8 h-8 rounded-full bg-gray-200 hover:bg-gray-300 flex items-center justify-center transition-colors cursor-pointer"
          >
            <i className="ri-close-line text-xl text-gray-600"></i>
          </button>
        </div>

        {/* Content */}
        <div className="p-8 overflow-y-auto h-[calc(100%-72px-88px)]">
          {!submitted ? (
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Phone */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  手机号 <span className="text-red-500">*</span>
                </label>
                <input
                  type="tel"
                  required
                  value={formData.phone}
                  onChange={(e) => setFormData({ ...formData, phone: e.target.value })}
                  placeholder="请输入您的手机号"
                  className="w-full h-12 px-4 border border-gray-300 rounded-lg focus:outline-none focus:border-[#14B8A6] transition-colors"
                />
              </div>

              {/* Revenue */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  年平台销售额区间 <span className="text-red-500">*</span>
                </label>
                <div className="space-y-2">
                  {['≤300万', '≤1000万', '更高'].map((option) => (
                    <label key={option} className="flex items-center gap-3 cursor-pointer">
                      <input
                        type="radio"
                        name="revenue"
                        value={option}
                        checked={formData.revenue === option}
                        onChange={(e) => setFormData({ ...formData, revenue: e.target.value })}
                        className="w-4 h-4 text-[#14B8A6] cursor-pointer"
                      />
                      <span className="text-sm text-gray-700">{option}</span>
                    </label>
                  ))}
                </div>
              </div>

              {/* Tax Service */}
              <div>
                <label className="flex items-start gap-3 cursor-pointer">
                  <input
                    type="checkbox"
                    checked={formData.needTaxService}
                    onChange={(e) => setFormData({ ...formData, needTaxService: e.target.checked })}
                    className="w-4 h-4 mt-0.5 text-[#14B8A6] cursor-pointer"
                  />
                  <div>
                    <span className="text-sm font-medium text-gray-700">是否需要退税服务包</span>
                    <div className="flex items-center gap-1 mt-1">
                      <span className="text-xs text-gray-500">叠加项</span>
                      <i className="ri-information-line text-gray-400 cursor-pointer" title="退税服务包为叠加项，不替代订阅费"></i>
                    </div>
                  </div>
                </label>
              </div>

              {/* Note */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  备注（选填）
                </label>
                <textarea
                  value={formData.note}
                  onChange={(e) => setFormData({ ...formData, note: e.target.value })}
                  placeholder="请输入您的需求或问题"
                  rows={4}
                  className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:border-[#14B8A6] transition-colors resize-none"
                ></textarea>
              </div>
            </form>
          ) : (
            <div className="text-center py-12">
              <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-check-line text-3xl text-green-600"></i>
              </div>
              <h4 className="text-xl font-bold text-gray-800 mb-2">提交成功</h4>
              <p className="text-gray-600 mb-8">
                我们已收到您的咨询，将尽快发送报价单或安排顾问联系您
              </p>
              <div className="bg-gray-50 rounded-lg p-6">
                <p className="text-sm text-gray-600 mb-4">扫码添加企业微信，获取更快响应</p>
                <div className="w-48 h-48 bg-white rounded-lg mx-auto flex items-center justify-center border border-gray-200">
                  <i className="ri-qr-code-line text-6xl text-gray-300"></i>
                </div>
              </div>
            </div>
          )}
        </div>

        {/* Footer */}
        {!submitted && (
          <div className="absolute bottom-0 left-0 right-0 h-[88px] bg-gray-50 border-t border-gray-200 flex items-center justify-center px-8">
            <button
              type="submit"
              onClick={handleSubmit}
              className="w-full h-12 bg-gradient-to-r from-[#FF6B35] to-[#FF8C42] text-white font-medium rounded-full hover:scale-105 transition-transform whitespace-nowrap cursor-pointer"
            >
              提交咨询
            </button>
          </div>
        )}
      </div>
    </>
  );
}
